import { WS_EVENT_TYPES } from "@/utils/constants";

export const ozlSocketService = {
  [WS_EVENT_TYPES.ORDER_ITEM_CREATE_OMTK_TENDER_EVENT](data) {
    const orderIndex = this.orders.findIndex((item) => item.id === data.id);
    if (orderIndex === -1) {
      data.show = true;
      this.orders.unshift({});
      this.$set(this.orders, 0, data);
    } else {
      let order = this.orders[orderIndex];
      order.items.push(data.items[0]);
      this.orders.splice(orderIndex, 1, order);
    }
  },
};
